import { gql, useQuery } from '@apollo/client';
import { useId } from 'react';
import FlaotingDropdown from '../FloatingDropdown/FloatingDropdown';
import Dropdown, { DropdownProps } from './Dropdown';

interface IOption {
  value: number;
  label: string;
}

// TODO: Should probably extend either DropdownProps or FloatingDropdownProps
interface Props extends Omit<DropdownProps<IOption>, 'id' | 'options' | 'label'> {
  label?: string;
  id?: string;
  defaultOption?: IOption | number;
  value?: IOption | number;
  inactive?: boolean;
  floating?: boolean;
  desktopWidth?: string;
  mobileWidth?: string;
}

const PROJECTLIST = gql`
  query UIKITProjectDropdown($inactive: Boolean) {
    projectList(inactive: $inactive) {
      projects {
        id
        displayName
      }
    }
  }
`;

function DropdownProject(props: Props) {
  const id = props.id || useId();

  const { data } = useQuery(PROJECTLIST, {
    variables: {
      inactive: props.inactive || null,
    },
  });

  let options: Array<IOption> = [];

  if (data && data.projectList && data.projectList.projects) {
    options = data.projectList?.projects?.map((item) => ({
      value: item.id,
      label: `${item.displayName}`,
    }));
    options.sort((a, b) => a.label.localeCompare(b.label));
  }
  if (props.floating) {
    return <FlaotingDropdown {...props} options={options} id={id} />;
  } else {
    return <Dropdown {...props} options={options} id={id} />;
  }
}

export default DropdownProject;
